import * as React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { Primary, mixins } from '@sphinx/components-styles'

interface LoadingProps {
  label?: string
  position?: Position
  size?: Size
}

export enum Position {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum Size {
  EXTRA_SMALL = '12px',
  SMALL = '16px',
  MEDIUM = '20px',
  LARGE = '28px',
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Circle = styled.div<{ size: Size }>`
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  border-radius: 50%;
  box-sizing: border-box;
  border: 2px solid ${Primary.orange[20]};
  border-top: 2px solid ${Primary.orange[100]};
  animation: ${spin} linear 1s infinite;
`

const Label = styled.span`
  ${mixins.menu}
  color: ${Primary.orange[100]};
  margin: 8px;
`

const positionToCss = {
  [Position.BOTTOM]: 'flex-direction: column;',
  [Position.TOP]: 'flex-direction: column-reverse;',
  [Position.LEFT]: 'flex-direction: row-reverse;',
  [Position.RIGHT]: 'flex-direction: row;',
}

const LoadingWrap = styled.div<{ position: Position }>`
  ${({ position }) => positionToCss[position]}
  display: inline-flex;
  justify-content: center;
  align-items: center;
`

export const Loading: React.FC<LoadingProps> = ({
  label,
  position = Position.RIGHT,
  size = Size.LARGE,
}) => (
  <LoadingWrap position={position}>
    <Circle size={size} />
    {label && <Label>{label}</Label>}
  </LoadingWrap>
)
